import React from 'react';
import I18n from 'i18n-js';
import { string } from 'prop-types';
import statusConfig from '../helpers/statusConfig';

const StatusLabel = ({ status = '' }) => {
  const config = statusConfig[status];
  return (
    <span
      className="tickets-index-page__status-label tickets-index-page__status-label--pill"
      style={{ backgroundColor: config.bg, color: config.color }}
    >
      {config.icon}
      {I18n.t(`tickets.statuses.${status}`)}
    </span>
  );
};

StatusLabel.propTypes = {
  status: string,
};

export default StatusLabel;
